// extracted by mini-css-extract-plugin
export default {"FormContainer":"Signup_FormContainer__fN0nV","AdditionalInfoContainer":"Signup_AdditionalInfoContainer__cRJhR","Link":"Signup_Link__5iIHD"};